import { useState, useEffect, useCallback } from 'react';

const COOKIE_NAME = 'tf_popup_shown';
const SUBMITTED_COOKIE_NAME = 'tf_popup_submitted';

function hasCookie(name) {
  return document.cookie.split('; ').some(c => c.startsWith(name + '='));
}

function setCookie(name, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=1; expires=${expires}; path=/`;
}

export function useExitIntent({ triggerType = 'exit' } = {}) {
  const [showPopup, setShowPopup] = useState(false);

  const triggerPopup = useCallback(() => {
    if (hasCookie(SUBMITTED_COOKIE_NAME) || hasCookie(COOKIE_NAME)) return;
    setCookie(COOKIE_NAME, 7);
    setShowPopup(true);
  }, []);

  const closePopup = useCallback(() => setShowPopup(false), []);

  const markSubmitted = useCallback(() => {
    setCookie(SUBMITTED_COOKIE_NAME, 365);
    setShowPopup(false);
  }, []);

  useEffect(() => {
    if (triggerType === 'time') {
      const timer = setTimeout(triggerPopup, 60000);
      return () => clearTimeout(timer);
    }

    if (triggerType === 'exit') {
      const handleMouseLeave = (e) => {
        if (e.clientY <= 0) triggerPopup();
      };
      const handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') triggerPopup();
      };
      document.addEventListener('mouseleave', handleMouseLeave);
      document.addEventListener('visibilitychange', handleVisibilityChange);
      return () => {
        document.removeEventListener('mouseleave', handleMouseLeave);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    }
  }, [triggerType, triggerPopup]);

  return { showPopup, closePopup, markSubmitted };
}
